import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  playPreExitAnimation?: () => Promise<void>;
  canDeactivate?: () => Observable<boolean> | Promise<boolean> | boolean;
  _exitAnimationPlayed?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PageExitAnimationGuard implements CanDeactivate<CanComponentDeactivate> {
  private isAnimationPlaying = false;

  async canDeactivate(
    component: CanComponentDeactivate
  ): Promise<boolean> {
    if (this.isAnimationPlaying) {
      return false;
    }

    if (component && typeof component.playPreExitAnimation === 'function') {
      if ((component as any)._exitAnimationPlayed) {
        return true;
      }

      this.isAnimationPlaying = true;
      
      try {
        const animationPromise = component.playPreExitAnimation();
        const timeoutPromise = new Promise<void>((resolve) => {
          setTimeout(() => resolve(), 1000);
        });
        
        await Promise.race([animationPromise, timeoutPromise]);
        return true;
      } catch (error) {
        console.error('Exit animation error:', error);
        return true;
      } finally {
        this.isAnimationPlaying = false;
      }
    }

    return true;
  }
}
